import { z } from 'zod';
import { BaseFieldDefinitionSchema } from './base';
import { ContentTypeSchema } from '../commons';
export var AssetFieldDefinition;
(function (AssetFieldDefinition) {
    AssetFieldDefinition.TYPE = 'assetReference';
})(AssetFieldDefinition || (AssetFieldDefinition = {}));
export const AssetFieldDefinitionSchema = BaseFieldDefinitionSchema.and(z.object({
    type: z.literal(AssetFieldDefinition.TYPE),
    i18n: z.boolean().optional(),
    validations: z
        .object({
        contentTypeRestrictions: z.array(ContentTypeSchema).optional()
    })
        .optional()
}));
//# sourceMappingURL=asset.js.map